export const ArrayToColumns = <T>(array: T[], columns: number): Array<Array<T>> => {
	const output: Array<Array<T>> = []

	for (let i = 0; i < columns; i++)
	{
		output.push([])
	}

	for (let i = 0; i < array.length; i++)
	{
		output[i % columns].push(array[i])
	}

	return output
}

export const Range = (start: number, end: number): number[] => {
	const output: number[] = []

	for (let i = start; i <= end; i++)
	{
		output.push(i)
	}

	return output
}

export const LimitObjectLength = <T>(obj: Record<any, T>, limit: number): Record<any, T> => {
	const output: Record<any, T> = {}

	Object.keys(obj).forEach((key, i) => {
		if (i < limit)
		{
			output[key] = obj[key]
		}
	})

	return output

}

export const ObjectMap = <T, U>(obj: Record<string, T>, fn: (t: T, key: string) => U): Record<string, U> => {
	const output: Record<string, U> = {}

	Object.keys(obj).forEach((key) => {
		output[key] = fn(obj[key], key)
	})

	return output
}

export const ObjectOrArrayMap = <T, U>(obj: Record<any, T> | T[], fn: (t: T, key: string | number) => U): Record<any, U> | U[] => {
	if (Array.isArray(obj))
	{
		return obj.map((t, i) => fn(t, i))
	}

	const o = ObjectMap(obj, fn)

	return o
}

export const ForceToArray = <T>(obj: Record<any, T> | T[]): T[] => {
	if (obj instanceof Array)
	{
		return obj as T[]
	}

	return Object.values(obj as Record<any, T>)
}